// recon-bank-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcb.match.matched': 'Conciliado con un asiento contable',
  'rcb.match.suggested': 'Coincidencia propuesta',
  'rcb.match.review': 'Para revisión manual',
  'rcb.match.unmatchedBank': 'Movimiento bancario sin coincidencia',
  'rcb.match.manual': 'Añadido manualmente',
  'rcb.match.excluded': 'Excluido',
  'rcb.match.noBankMatch': 'Asiento contable sin coincidencia bancaria',
  'rcb.status.new': 'Sin tratar',
  'rcb.status.suggested': 'Propuesta pendiente',
  'rcb.status.review': 'Para revisión',
  'rcb.status.booked': 'Contabilizado',
  'rcb.status.approved': 'Aprobado',
  'rcb.status.private': 'Privado',
  'rcb.status.operating': 'Operativo',
  'rcb.status.ignored': 'Ignorado',
  'rcb.status.manual': 'Añadido manualmente',
  'rcb.line.fallback': 'Movimiento bancario',
  'rcb.source.private': 'Cuenta privada',
  'rcb.source.statement': 'Extracto bancario',
  'rcb.source.none': 'Sin extracto',
  'rcb.cov.none': 'Sin extracto bancario para el periodo',
  'rcb.cov.missingRange': 'falta desde {from} hasta {to}',
  'rcb.cov.and': '{first} y {second}',
  'rcb.check.coverage': 'La base bancaria cubre todo el periodo',
  'rcb.check.balance': 'El saldo contabilizado coincide con el saldo bancario',
  'rcb.check.notBooked': 'Todos los movimientos bancarios están contabilizados',
  'rcb.check.review': 'Ninguna línea está pendiente de revisión manual',
  'rcb.check.missingVoucher': 'Los pagos tienen justificante',
  'rcb.check.duplicate': 'Los posibles duplicados se han evaluado',
  'rcb.check.noBankMatch': 'Todos los asientos de las cuentas bancarias tienen un movimiento bancario',
  'rcb.check.staleTransit': 'Ningún asiento antiguo está esperando al banco',
  'rcb.check.internal': 'Las transferencias internas cuadran',
});
